import styled, { css } from 'styled-components';
import type { FontWeightName, TextSize } from '@makemydeal/dr-ui-bricks-types';
import { textFontStyles } from '../typographyScale/fontStyles';

// theme.uiBricks is a flat token map (or undefined outside sales-checkin); cast inline at use site.
export const StyledText = styled.p<{ $size: TextSize; $weight: FontWeightName; $color?: string }>`
    margin: 0;
    ${({ $size, $weight }) => textFontStyles($size, $weight)}
    ${({ theme, $color }) => {
        const color = $color ?? (theme as { uiBricks?: Record<string, string> }).uiBricks?.primaryFontColor;
        return (
            color &&
            css`
                color: ${color};
            `
        );
    }}
`;
